import { render, staticRenderFns } from "./ColorForm.vue?vue&type=template&id=cffacd84&"
import script from "./ColorForm.vue?vue&type=script&lang=js&"
export * from "./ColorForm.vue?vue&type=script&lang=js&"
import style0 from "./ColorForm.vue?vue&type=style&index=0&id=cffacd84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports